export class Constants{
    public static readonly MINIMUM_AMOUNT = 10000;
    public static readonly WITHDRAW_MINIMUM_AMOUNT = 1000;
    public static readonly MAXIMUM_AMOUNT = 5000000;
    public static readonly POPUP_TIMEOUT = 10000;
}